import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["title", "purchasePrice", "sellingPrice", "warranty", "quantity", "titleError"]
  static values = { titleRequiredText: String }

  add(event) {
    event.preventDefault()

    const title = this.titleTarget.value.trim()
    if (title.length === 0) {
      this.showTitleError()
      return
    }

    this.clearTitleError()

    window.dispatchEvent(new CustomEvent("retail-order:add-quick-sale", {
      detail: {
        title,
        purchasePrice: this.purchasePriceTarget.value,
        sellingPrice: this.sellingPriceTarget.value,
        warranty: this.warrantyTarget.value,
        quantity: this.quantityTarget.value
      }
    }))

    document.getElementById("modal").replaceChildren()
  }

  showTitleError() {
    this.titleErrorTarget.textContent = this.titleRequiredTextValue
    this.titleErrorTarget.classList.remove("hidden")
    this.titleTarget.classList.remove("border-gray-300", "focus:border-primary-500")
    this.titleTarget.classList.add("border-red-300", "focus:border-red-500")
    this.titleTarget.focus()
  }

  clearTitleError() {
    this.titleErrorTarget.classList.add("hidden")
    this.titleTarget.classList.remove("border-red-300", "focus:border-red-500")
    this.titleTarget.classList.add("border-gray-300", "focus:border-primary-500")
  }
}
